import moment from "moment";
import { GET_ALL_CONTENT_DATA, GET_EVENT_VOICE, GET_LEADER_BOARD, GET_TRUE_SENSE_RECOMMENDATION, GET_WORD_CLOUD, UPDATE_SELECTED_FEED_DATA, GET_SENTIMENTS_DATA, GET_ASSETS_NETWORK, GET_CONTENT_ANALYTICS, GET_SCREEN_ANALYTICS_DATA, GET_SCREEN_OVERVIEW_DATA, GET_TOP_REACTED_POSTS_DATA, GET_PERFORMING_POST_DATA, GET_WEB_ANALYTIC_DATA, GET_POST_TYPE_COUNT, GET_WEB_POST_OVERVIEW_DATA, ACTIVE_TAB, GET_FLAGES, PAGE_REFRESH, CONTENT_LOADER, SENTIMENT_LOADER, LEADER_BOARD_LOADER, TOP_EVENT_LOADER, TRUSENSE_LOADER, WORD_LOADER, POSTS_BY_NETWORK_LOADER, GET_SCREEN_ANALYTICS_LOADER, GET_SCREEN_OVERVIEW_DATA_LOADER, GET_TOP_REACTED_POSTS_DATA_LOADER, GET_PERFORMING_POST_LOADER, GET_WEB_ANALYTIC_LOADER, GET_WEB_POST_OVERVIEW_LOADER, POST_TYPE_COUNT_LOADER, GET_WALL_SENTIMENT_LIVE_TREND_DATA, GET_WALL_SENTIMENT_LIVE_TREND_LOADER, GET_TOP_AI_TAGS, GET_POST_LANGUAGE, ANALYTICS_STATUS_LOADER, POST_BY_LANGUAGE_LOADER, TOP_AI_LOADER, UPDATE_FILTER_DATE, UPDATE_FEEDS, REMOVE_WALL, } from "../reducers/keys";
import store from "../store";
import HttpClient from "./http-client";
import { API_GET_WALL_RECORD_MOST_ACTIVE_USERS, API_GET_WALL_RECORD_WORD_CLOUD, API_GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS, API_GET_WALL_RECORD_OVERVIEW, GET_WALL_FEED, API_GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS_MORE, GET_ANALYTICS_STATUS, } from "./api";
import { API_GET_TOP_PERFORMING_POST, API_GET_TOP_REACTION_POST, API_GET_WEB_POST_OVERVIEW, CLOUD_URL, GET_ACTIVITY_WEB_REC, GET_EVENT_VOICE_RECORDS, GET_POST_BY_NETWORK_RECORDS, GET_SCREEN_ANALYTICS, GET_SCREEN_OVERVIEW_NEW, GET_TRUE_SENSE, GET_WALL_POST_BY_TYPE, GET_WALL_SENTIMENT_LIVE_TREND, LIVE_API, } from "./api";
import { getFlags, getUserTags } from "./loginActions";
import { ANALYTICS_STATUS, GET_USER_FEEDS, PAGE_NOT_FOUND, UPDATE_WALL_AND_FEED, } from "../reducers/keys";


export const activeTab = (props) => {
  return (dispatch) => {
    dispatch({ type: ACTIVE_TAB, payload: props });
  };
};


export const getWallFeedsCallBackRequest = (userID, dispatch, callBack) => {

  const isCollaborator = localStorage.getItem('isCollaborator');
  const loginOwnerId = localStorage.getItem('loginOwnerId');
  const { userfeeds } = store.getState().analyticwall;
  const wallId = localStorage.getItem('wallId');

  dispatch({ type: PAGE_NOT_FOUND, payload: false });

  if (userfeeds && userfeeds.length > 0) {
    dispatch({ type: GET_USER_FEEDS, payload: { data: userfeeds, selectedData: wallIDFetch(wallId, userfeeds) }, });
    dispatch({ type: UPDATE_WALL_AND_FEED, payload: wallIDFetch(wallId, userfeeds), });
    setTimeout(() => { dispatch({ type: ANALYTICS_STATUS_LOADER, payload: true }); if (callBack) callBack(userfeeds) }, 1000);

  } else {
    new HttpClient().get(`${GET_WALL_FEED}/${userID}/${loginOwnerId}/${isCollaborator}/0/${isCollaborator}`).then((response) => {
      const feedsData = response.data.responseData || response.data;
      dispatch({ type: GET_USER_FEEDS, payload: { data: feedsData, selectedData: wallIDFetch(wallId, feedsData) }, });
      dispatch({ type: UPDATE_WALL_AND_FEED, payload: wallIDFetch(wallId, feedsData), });
      setTimeout(() => { dispatch({ type: ANALYTICS_STATUS_LOADER, payload: true }); if (callBack) callBack(feedsData) }, 1000);

    })
      .catch((error) => {
        if (callBack) callBack(null);
        dispatch({ type: PAGE_NOT_FOUND, payload: true });
        dispatch({ type: ANALYTICS_STATUS_LOADER, payload: true });
      });
  }
}



export const getAnalytcialStatus = (wallId, callback = 0) => {
  const ownerId = localStorage.getItem('ownerId');
  const { userData } = store.getState().authenticated;


  return (dispatch) => {
    startLoadingComponent(dispatch, 0)
    dispatch({ type: PAGE_NOT_FOUND, payload: false });
    dispatch({ type: ANALYTICS_STATUS_LOADER, payload: false });
    new HttpClient().get(`${GET_ANALYTICS_STATUS}/${wallId}`).then((response) => {
      const { responseCode, responseData } = response.data;
      if (responseCode == 200) {
        getWallFeedsCallBackRequest(ownerId, dispatch, (feeds) => {
          const isFreePlan = (userData && userData.UserPlan && Object.keys(userData.UserPlan).length > 0) ? String(userData.UserPlan.planId).includes("58") : false;

          const filteredList = !isFreePlan ? feeds && feeds.length > 0 ? feeds.filter(feed => (feed && feed.wall && feed.wall.id == wallId)) : [] : [];
          const showDemoData = filteredList.reduce((acc, curr) => {
            if (curr && curr.postCount != 0) acc = false;
            return acc;
          }, true);


          dispatch({ type: ANALYTICS_STATUS, payload: { ...responseData, webAnalytic: !showDemoData } });
          dispatch({ type: ANALYTICS_STATUS_LOADER, payload: true });
        });
      }

    }).catch((error) => {
      console.error("LAYOUT ISSUE", error)
      dispatch({ type: PAGE_NOT_FOUND, payload: true });
    });
  }
}

export const refreshButton = (isTrial) => {
  return (dispatch) => {

    if (isTrial) {
      startLoadingComponent(dispatch, 0)
      getdemoData(dispatch)
    } else {

      const isCollaborator = localStorage.getItem("isCollaborator");
      const loginOwnerId = localStorage.getItem("loginOwnerId");
      const ownerID = localStorage.getItem("ownerId");
      const getWallID = localStorage.getItem("wallId");
      const { activeTab } = store.getState().analyticsRecords;

      dispatch({ type: PAGE_REFRESH, payload: true });
      startLoadingComponent(dispatch, activeTab);

      new HttpClient().get(`${GET_WALL_FEED}/${ownerID}/${loginOwnerId}/${isCollaborator}/0/${isCollaborator}`).then((response) => {
        dispatch({ type: GET_USER_FEEDS, payload: { data: response.data, selectedData: wallIDFetch(getWallID, response.data), }, });
        dispatch({ type: UPDATE_WALL_AND_FEED, payload: wallIDFetch(getWallID, response.data), });
        setTimeout(() => { extendsRefreshButton(dispatch, isTrial, activeTab); }, 2000);
      })
        .catch((error) => {
          console.error("LAYOUT ISSUE", error);
          setTimeout(() => dispatch({ type: PAGE_REFRESH, payload: false }), 2000);
        });
    }
  }
}


export const swithcWall = () => {
  return (dispatch) => {
    startLoadingComponent(dispatch, 1)
  }
}

export const startLoadingComponent = (dispatch, activeTab, value = true) => {

  if (activeTab == 1 || !activeTab) {
    dispatch({ type: CONTENT_LOADER, payload: true });
    dispatch({ type: SENTIMENT_LOADER, payload: value });
    dispatch({ type: LEADER_BOARD_LOADER, payload: value });
    dispatch({ type: TOP_EVENT_LOADER, payload: value });
    dispatch({ type: TRUSENSE_LOADER, payload: value });
    dispatch({ type: POST_TYPE_COUNT_LOADER, payload: value });
    dispatch({ type: WORD_LOADER, payload: value });
    dispatch({ type: GET_WALL_SENTIMENT_LIVE_TREND_LOADER, payload: value });
    dispatch({ type: POSTS_BY_NETWORK_LOADER, payload: value });
    dispatch({ type: POST_BY_LANGUAGE_LOADER, payload: value });
    dispatch({ type: TOP_AI_LOADER, payload: value });
  }

  if (activeTab == 2 || !activeTab) {
    dispatch({ type: GET_TOP_REACTED_POSTS_DATA_LOADER, payload: value });
    dispatch({ type: GET_PERFORMING_POST_LOADER, payload: value });
    dispatch({ type: GET_WEB_ANALYTIC_LOADER, payload: value });
    dispatch({ type: GET_WEB_POST_OVERVIEW_LOADER, payload: value });
  }


  if (activeTab == 3) {
    dispatch({ type: GET_SCREEN_ANALYTICS_LOADER, payload: value });
    dispatch({ type: GET_SCREEN_OVERVIEW_DATA_LOADER, payload: value });
  }
};

const extendsRefreshButton = (dispatch, isTrial, activeTab) => {

  if (isTrial) {
    return (dispatch) => {
      startLoadingComponent(dispatch, 0)
      getdemoData(dispatch)
    }
  } else {

    const { selectedWallFeed, dateFilter, selectedFeed, postType } =
      store.getState().analyticwall;

    if (activeTab == 3) {
      getScreenAnalytics(dispatch);
      getScreenOverview(dispatch);
    } else {
      let wallData = null;
      if (selectedWallFeed && selectedWallFeed?.wall) { wallData = selectedWallFeed?.wall?.id; }
      let startDate = dateFilter.startDate;
      let endDate = dateFilter.endDate;
      let feedIDs = [];
      if (selectedFeed && selectedFeed.length > 0) {
        selectedFeed.map((fItem) => { feedIDs.push(fItem.value); });
      }
      let updatePostType = updatePostData(postType);
      fetchData(dispatch, wallData, getDate(startDate), getDate(endDate), feedIDs.join(), 5, updatePostType);
    }
  }
};

const wallIDFetch = (wallID, data) => {
  if (data && data.length > 0) {
    if (wallID) {
      const filterData = data.filter((item) => item.wall.id == wallID);
      if (filterData && filterData.length > 0) return filterData[0];
      else return data[0];
    } else return data[0];
  }
};


export const updateFilterDate = (data, callbackFeed) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_FILTER_DATE, payload: data, });
    callbackFeed(data.startDate, data.endDate)
  }
}


export const updateSelectedFeed = (feedData, isTrial, filterDate = null) => {

  if (isTrial || !feedData.length) {
    return (dispatch) => {
      dispatch({ type: UPDATE_SELECTED_FEED_DATA, payload: feedData, });
      startLoadingComponent(dispatch, 0)
      getdemoData(dispatch)
    }
  } else {

    const { analyticsRecords } = store.getState();
    const { selectedWallFeed, dateFilter, postType } = analyticsRecords;

    let wallData = selectedWallFeed && selectedWallFeed.wall ? selectedWallFeed.wall.id : null;

    let startDate = filterDate ? filterDate.startDate : moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss');
    let endDate = filterDate ? filterDate.endDate : dateFilter.endDate;
    let feedIDs = getFeedData(feedData)
    let updatePostType = updatePostData(postType);

    return (dispatch) => {
      fetchData(dispatch, wallData, getDate(startDate), getDate(endDate), feedIDs.join(), 5, 0, updatePostType, "");
      dispatch({ type: UPDATE_SELECTED_FEED_DATA, payload: feedData, });
    }
  }
}

const fetchData = (dispatch, wallID, startDate, endDate, feedID, limit, offset, postType, username) => {

  const { activeTab } = store.getState().analyticsRecords;
  const getWallID = localStorage.getItem("wallId");
  const feedData = feedID && feedID.length > 0 ? feedID : 0;

  const requestData = (func, additionalArgs = []) => {
    func(dispatch, getWallID, startDate, endDate, feedData, offset, limit, postType ? postType : 0, username ? username : "", ...additionalArgs);
  };

  if (activeTab == 1) {
    requestData(getcontetAnalytics);
    requestData(gettrueSenseRecommendation);
    requestData(getwallRecordWordCloud);
    requestData(getwallpostbyType);
    requestData(getsentimentLiveTrend);
    requestData(getwallRecordSentimentByPostStatistics);
    requestData(getPostbyNetwork);
    requestData(getwallRecordMostActiveUsers);
    requestData(getEventVoices);
    requestData(getUserTags(localStorage.getItem('ownerId')));
    requestData(getLanguageTags);
  }

  if (activeTab == 2) {
    requestData(getwebAnalytics);
    requestData(gettopReactionPost);
    requestData(getPerformingPost);
    requestData(getPostOverview);
  }

  if (activeTab == 1 || activeTab == 2)
    setTimeout(() => dispatch({ type: PAGE_REFRESH, payload: false }), 2000);
};

// CONTENT TAB -------------

export const getScreenAnalyticsData = (isTrial) => {
  return (dispatch) => {
    if (isTrial) {
      startLoadingComponent(dispatch, 0)
      getdemoData(dispatch)
    } else {
      getScreenAnalytics(dispatch);
      getScreenOverview(dispatch);
    }
    setTimeout(() => dispatch({ type: PAGE_REFRESH, payload: false }), 2000);
  };
};



const getLanguageTags = (dispatch, wallID) => {

  const loginOwnerId = localStorage.getItem('ownerId');
  const GET_LANGUAGE_JSON = !LIVE_API ? `${CLOUD_URL}test/widgetDisplay` : `https://cloud.socialwalls.com`;

  new HttpClient().get(`${GET_LANGUAGE_JSON}/media/${loginOwnerId}/${wallID}/language_${loginOwnerId}.json`).then((response) => {
    const { data } = response;
    dispatch({ type: GET_POST_LANGUAGE, payload: data });
    dispatch({ type: PAGE_REFRESH, payload: false })
  })
    .catch((error) => {
      dispatch({ type: POST_BY_LANGUAGE_LOADER, payload: false });
      dispatch({ type: PAGE_REFRESH, payload: false })
      console.error("LAYOUT ISSUE", error);
    });
}

const getScreenAnalytics = (dispatch) => {
  dispatch({ type: GET_SCREEN_ANALYTICS_LOADER, payload: true });
  new HttpClient().get(`${GET_SCREEN_ANALYTICS}/${localStorage.getItem("wallId")}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_SCREEN_ANALYTICS_DATA, payload: responseData });
    dispatch({ type: PAGE_REFRESH, payload: false })
  })
    .catch((error) => {
      dispatch({ type: GET_SCREEN_ANALYTICS_LOADER, payload: false });
      dispatch({ type: PAGE_REFRESH, payload: false })
      console.error("LAYOUT ISSUE", error);
    });
};

const getScreenOverview = (dispatch) => {
  dispatch({ type: GET_SCREEN_OVERVIEW_DATA_LOADER, payload: true });
  new HttpClient().get(`${GET_SCREEN_OVERVIEW_NEW}/${localStorage.getItem("wallId")}/0/15`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_SCREEN_OVERVIEW_DATA, payload: responseData });
    dispatch({ type: PAGE_REFRESH, payload: false })
  })
    .catch((error) => {
      dispatch({ type: GET_SCREEN_OVERVIEW_DATA_LOADER, payload: false });
      dispatch({ type: PAGE_REFRESH, payload: false })
      console.error("LAYOUT ISSUE", error);
    });
};



export const getScreenOverviewMore = (wallID, offset, limit, username) => {
  return new HttpClient().get(`${GET_SCREEN_OVERVIEW_NEW}/${wallID}/${offset}/${limit}/${username ? `/${username}` : ""}`);
};


// CONTENT SECTION API FUNCTION

const getcontetAnalytics = (dispatch, wallID, startDate, endDate, feedID, postType) => {
  const duplicatePostId = 0;
  dispatch({ type: CONTENT_LOADER, payload: true });
  new HttpClient().get(`${API_GET_WALL_RECORD_OVERVIEW}/${wallID}/${startDate}/${endDate}/${feedID}/${postType}/${duplicatePostId ? duplicatePostId : 0}`).then((response) => {
    const { responseData } = response.data;
    if (responseData && Object.keys(responseData).length)
      dispatch({ type: GET_CONTENT_ANALYTICS, payload: responseData });
    dispatch({ type: CONTENT_LOADER, payload: false });
  })
    .catch((error) => {
      dispatch({ type: CONTENT_LOADER, payload: false });
      console.error("LAYOUT ISSUE", error);
    });
};

const getwallRecordWordCloud = (dispatch, wallID, startDate, endDate, feedID, postType) => {
  dispatch({ type: WORD_LOADER, payload: true });
  new HttpClient().get(`${API_GET_WALL_RECORD_WORD_CLOUD}/${wallID}/${startDate}/${endDate}/${feedID}/${postType}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_WORD_CLOUD, payload: responseData });
  })
    .catch((error) => {
      console.error("LAYOUT ISSUE", error);
      dispatch({ type: WORD_LOADER, payload: false });
    });
};

const gettrueSenseRecommendation = (dispatch, wallID, startDate, endDate, feedID, postType) => {
  const { duplicatePostId } = store.getState().analyticsStatusD;
  dispatch({ type: TRUSENSE_LOADER, payload: true });
  new HttpClient().get(`${GET_TRUE_SENSE}/${wallID}/${startDate}/${endDate}/${feedID}/${postType}/${duplicatePostId ? duplicatePostId : 0}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_TRUE_SENSE_RECOMMENDATION, payload: responseData });
  })
    .catch((error) => {
      dispatch({ type: TRUSENSE_LOADER, payload: true });
      console.error("LAYOUT ISSUE", error);
    });
};

const getwallpostbyType = (dispatch, wallID, startDate, endDate, feedID, limit, postType) => {
  dispatch({ type: POST_TYPE_COUNT_LOADER, payload: true });
  new HttpClient().get(`${GET_WALL_POST_BY_TYPE}/${wallID}/${startDate}/${endDate}/${feedID}/${limit}/${postType}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_POST_TYPE_COUNT, payload: responseData });
  })
    .catch((error) => {
      console.error("LAYOUT ISSUE", error);
      dispatch({ type: POST_TYPE_COUNT_LOADER, payload: false });
    });
};


const getwallRecordSentimentByPostStatistics = (dispatch, wallID, startDate, endDate, feedID, postType) => {
  dispatch({ type: SENTIMENT_LOADER, payload: true });
  new HttpClient().get(`${API_GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS}/${wallID}/${startDate}/${endDate}/${feedID}/${postType}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_SENTIMENTS_DATA, payload: responseData });
  })
    .catch((error) => {
      console.error("LAYOUT ISSUE", error);
      dispatch({ type: SENTIMENT_LOADER, payload: false });
    });
};

export const getsentimentLiveTrenddateRange = (dateValue) => {
  return (dispatch) => {
    const { selectedFeed } = store.getState().analyticwall;
    const wallData = localStorage.getItem("wallId");
    let feedIDs = getFeedData(selectedFeed)
    getsentimentLiveTrend(dispatch, wallData, "", "", feedIDs.join(), dateValue);
  };
};

const getsentimentLiveTrend = (dispatch, wallID, startDate = 0, endDate = 0, feedID, dateValue) => {

  const getDate = moment().subtract(dateValue == 48 ? 2 : 1, 'days')
  const startDt = getDate.utc().unix();
  const endDt = moment().utc().unix();

  dispatch({ type: GET_WALL_SENTIMENT_LIVE_TREND_LOADER, payload: true });
  new HttpClient().get(`${GET_WALL_SENTIMENT_LIVE_TREND}/${wallID}/${startDt}/${endDt}/${feedID}/${0}`).then((response) => {
    const { responseData } = response.data;
    dispatch({
      type: GET_WALL_SENTIMENT_LIVE_TREND_DATA,
      payload: responseData,
    });
  })
    .catch((error) => {
      console.error("LAYOUT ISSUE", error);
      dispatch({ type: GET_WALL_SENTIMENT_LIVE_TREND_LOADER, payload: false });
    });
};

const getPostbyNetwork = (dispatch, wallID, startDate, endDate, feedID, limit, postType) => {
  dispatch({ type: POSTS_BY_NETWORK_LOADER, payload: true });
  new HttpClient().get(`${GET_POST_BY_NETWORK_RECORDS}/${wallID}/${startDate}/${endDate}/${feedID}/${limit}/${postType}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_ASSETS_NETWORK, payload: responseData });
  })
    .catch((error) => {
      console.error("LAYOUT ISSUE", error);
      dispatch({ type: POSTS_BY_NETWORK_LOADER, payload: false });
    });
};

export const getwallRecordMostActiveUsers = (dispatch, wallID, startDate, endDate, feedID, offset, limit, postType, username) => {

  dispatch({ type: LEADER_BOARD_LOADER, payload: true });
  new HttpClient().get(`${API_GET_WALL_RECORD_MOST_ACTIVE_USERS}/${wallID}/${startDate}/${endDate}/${feedID}/${offset}/${limit}/${postType}${username ? `/${username}` : ""}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_LEADER_BOARD, payload: responseData });
  })
    .catch((error) => {
      console.error("LAYOUT ISSUE", error);
      dispatch({ type: LEADER_BOARD_LOADER, payload: false });
    });
};

const getEventVoices = (dispatch, wallID, startDate, endDate, feedID, postType) => {
  dispatch({ type: TOP_EVENT_LOADER, payload: true });
  new HttpClient().get(`${GET_EVENT_VOICE_RECORDS}/${wallID}/${startDate}/${endDate}/${feedID}/0/6`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_EVENT_VOICE, payload: responseData });
  })
    .catch((error) => {
      console.error("LAYOUT ISSUE", error);
      dispatch({ type: TOP_EVENT_LOADER, payload: false });
    });
};

// CONTENT SECTION API FUNCTION

// ACTIVE HUB SECTION API FUNCTION

const getwebAnalytics = (dispatch, wallID, startDate, endDate) => {
  dispatch({ type: GET_WEB_ANALYTIC_LOADER, payload: true });
  new HttpClient().get(`${GET_ACTIVITY_WEB_REC}/${wallID}/${startDate}/${endDate}`).then((response) => {
    const { responseData } = response.data;
    if (responseData && Object.keys(responseData).length)
      dispatch({ type: GET_WEB_ANALYTIC_DATA, payload: responseData });
  })
    .catch((error) => {
      dispatch({ type: GET_WEB_ANALYTIC_LOADER, payload: false });
      console.error("LAYOUT ISSUE", error);
    });
};

const gettopReactionPost = (dispatch, wallID, startDate, endDate, feedID, offset, limit, postType) => {

  dispatch({ type: GET_TOP_REACTED_POSTS_DATA_LOADER, payload: true });
  new HttpClient().get(`${API_GET_TOP_REACTION_POST}/${wallID}/${startDate}/${endDate}/${feedID}/${offset}/10/${postType}`).then((response) => {
    const { responseData } = response.data;
    dispatch({ type: GET_TOP_REACTED_POSTS_DATA, payload: responseData });
  })
    .catch((error) => {
      dispatch({ type: GET_TOP_REACTED_POSTS_DATA_LOADER, payload: true });
      console.error("LAYOUT ISSUE", error);
    });
};

const getPerformingPost = (dispatch, wallID, startDate, endDate, feedID, offset, limit, postType) => {
  dispatch({ type: GET_PERFORMING_POST_LOADER, payload: true });
  new HttpClient().get(`${API_GET_TOP_PERFORMING_POST}/${wallID}/${startDate}/${endDate}/${feedID}/${offset}/10/${postType}`).then((response) => {
    const { responseData } = response.data;

    dispatch({ type: GET_PERFORMING_POST_DATA, payload: responseData });
  })
    .catch((error) => {
      dispatch({ type: GET_PERFORMING_POST_LOADER, payload: true });
      console.error("LAYOUT ISSUE", error);
    });
};

const getPostOverview = (dispatch, wallID, startDate, endDate) => {
  dispatch({ type: GET_WEB_POST_OVERVIEW_LOADER, payload: true });
  new HttpClient().get(`${API_GET_WEB_POST_OVERVIEW}/${wallID}/${startDate}/${endDate}`).then((response) => {
    const { responseData } = response.data;

    dispatch({ type: GET_WEB_POST_OVERVIEW_DATA, payload: responseData });
  })
    .catch((error) => {
      dispatch({ type: GET_WEB_POST_OVERVIEW_LOADER, payload: true });
      console.error("LAYOUT ISSUE", error);
    });
};

// GET MORE DATA APIS FUNCTION

export const getwallRecordMostActiveUsersMore = (wallID, startDate, endDate, feedID, offset, limit, postType, username) => {
  return new HttpClient().get(
    `${API_GET_WALL_RECORD_MOST_ACTIVE_USERS}/${wallID}/${startDate}/${endDate}/${feedID}/${offset}/${limit}/${postType}${username ? `/${username}` : ""
    }`
  );
};

export const getPrfomingPostMore = (wallID, startDate, endDate, feedID, offset, limit, postType, username) => {
  return new HttpClient().get(
    `${API_GET_TOP_PERFORMING_POST}/${wallID}/${startDate}/${endDate}/${feedID}/${offset}/${limit}/${postType}${username ? `/${username}` : ""
    }`
  );
};

export const getreactedpostsMore = (wallID, startDate, endDate, feedID, offset, limit, postType, username) => {
  return new HttpClient().get(
    `${API_GET_TOP_REACTION_POST}/${wallID}/${startDate}/${endDate}/${feedID}/${offset}/${limit}/${postType}${username ? `/${username}` : ""
    }`
  );
};

export const getwallRecordSentimentByPostStatisticsNagativeMore = (wallID, startDate, endDate, feedID, offset, limit, username) => {
  return new HttpClient().get(
    `${API_GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS_MORE}/${wallID}/${startDate}/${endDate}/${feedID}/negative/${offset}/${limit}${username ? `/${username}` : ""
    }`
  );
};

export const getwallRecordSentimentByPostStatisticsPositiveMore = (wallID, startDate, endDate, feedID, offset, limit, username) => {
  return new HttpClient().get(
    `${API_GET_WALL_RECORD_SENTIMENT_BY_POST_STATISTICS_MORE}/${wallID}/${startDate}/${endDate}/${feedID}/positive/${offset}/${limit}${username ? `/${username}` : ""
    }`
  );
};

export const getEventVoicesMore = (wallID, startDate, endDate, feedID, offset, limit, postType, username) => {
  return new HttpClient().get(`${GET_EVENT_VOICE_RECORDS}/${wallID}/${startDate}/${endDate}/${feedID}/${offset}/${limit}${username ? `/${username}` : ""}`);
};


export const getdemoData = (dispatch) => {
  const url = `https://cloud.socialwalls.com/react-app/analytics/analyticsLive.json?v=1`;

  new HttpClient().get(url).then((response) => {
    const { getActivityWebRec, getAnalyticsScreensOverview, tags, language, getAnalyticsWebPostOverview, getScreenAnalyticsRecords, getSentimentLiveTrend, getTopPerformingPosts, getTopReactionPosts, getTruSenseRec, getWallPostsbyNwk, getWallPostsbyType, getWallTopEventVoices, getwallRecordMostActiveUsers, getwallRecordOverview, getwallRecordSentimentByPostStatistics, getwallRecordWordCloud, } = response.data;

    dispatch({ type: GET_CONTENT_ANALYTICS, payload: getwallRecordOverview.responseData, });
    dispatch({ type: GET_EVENT_VOICE, payload: getWallTopEventVoices.responseData, });
    dispatch({ type: GET_LEADER_BOARD, payload: getwallRecordMostActiveUsers.responseData, });
    dispatch({ type: GET_WORD_CLOUD, payload: getwallRecordWordCloud.responseData, });
    dispatch({ type: GET_TRUE_SENSE_RECOMMENDATION, payload: getTruSenseRec.responseData, });
    dispatch({ type: GET_SENTIMENTS_DATA, payload: getwallRecordSentimentByPostStatistics.responseData, });
    dispatch({ type: GET_WALL_SENTIMENT_LIVE_TREND_DATA, payload: getSentimentLiveTrend.responseData, });
    dispatch({ type: GET_ASSETS_NETWORK, payload: getWallPostsbyNwk.responseData, });
    dispatch({ type: GET_POST_TYPE_COUNT, payload: getWallPostsbyType.responseData, });
    dispatch({ type: GET_TOP_AI_TAGS, payload: tags?.responseData });
    dispatch({ type: GET_POST_LANGUAGE, payload: language?.responseData });
    dispatch({ type: GET_WEB_ANALYTIC_DATA, payload: getActivityWebRec.responseData, });
    dispatch({ type: GET_TOP_REACTED_POSTS_DATA, payload: getTopReactionPosts, });
    dispatch({ type: GET_PERFORMING_POST_DATA, payload: getTopPerformingPosts.responseData, });
    dispatch({ type: GET_WEB_POST_OVERVIEW_DATA, payload: getAnalyticsWebPostOverview.responseData, });
    dispatch({ type: GET_SCREEN_OVERVIEW_DATA, payload: getAnalyticsScreensOverview.responseData, });
    dispatch({ type: GET_SCREEN_ANALYTICS_DATA, payload: getScreenAnalyticsRecords.responseData, });
  });
};


const getDate = (date) => moment(date).format("YYYY-MM-DD HH:mm:ss")

const getFeedData = (feedData) => {
  let feedIDs = [];
  if (feedData && feedData.length > 0) {
    feedData.map((fItem) => { feedIDs.push(fItem.value); });
  }
  return feedIDs
}

const updatePostData = (postType) => {
  var updatePostType = 0;
  if (postType && postType.length > 0) {
    if (postType && postType.length == 2) updatePostType = 0;
    else if (postType.length == 1) {
      postType.map((chItem) => {
        updatePostType = parseInt(chItem.value);
      });
    }
  }
  return updatePostType;
};

export const updateFlags = () => {
  return (dispatch) => {
    getFlags().then((response) => {
      const flags = response.data;
      if (flags && flags.length > 0) {
        dispatch({ type: GET_FLAGES, payload: flags });
      }
    })
      .catch((ex) => { });
  };
};

export const getAllContentData = () => {
  return (dispatch) => {
    dispatch({ type: GET_ALL_CONTENT_DATA, payload: 1 });
  };
};

// export const getAllDisplayData = () => {
//   return (dispatch) => {
//     dispatch({ type: GET_ALL_DISPLAY_DATA, payload: 1 });
//   };
// };

// export const getWidgetAllData = (dispatch) => {
//   return (dispatch) => {
//     dispatch({ type: GET_ALL_WIDGET_DATA, payload: 1 });
//   };
// };













export const getWallFeeds = (userID) => {
  return (dispatch) => {
    const isCollaborator = localStorage.getItem('isCollaborator');
    const loginOwnerId = localStorage.getItem('loginOwnerId');
    dispatch({ type: PAGE_NOT_FOUND, payload: false });
    new HttpClient()
      .get(`${GET_WALL_FEED}/${userID}/${loginOwnerId}/${isCollaborator}/0/${isCollaborator}`)
      .then((response) => {
        const getWallID = localStorage.getItem('wallId');
        dispatch({ type: GET_USER_FEEDS, payload: { data: response.data, selectedData: wallIDFetch(getWallID, response.data) }, });
        dispatch({ type: UPDATE_WALL_AND_FEED, payload: wallIDFetch(getWallID, response.data), });

      })
      .catch((error) => {
        console.error("LAYOUT ISSUE", error)
        dispatch({ type: PAGE_NOT_FOUND, payload: true });
      });
  }
};

export const updateFeeds = (feed) => { return { type: UPDATE_FEEDS, payload: feed }; }
export const GET_INSTAGRAM_IMAGE = (instagramUrl) => new HttpClient().get(instagramUrl);
export const removeWall = (wallId) => { return { type: REMOVE_WALL, payload: wallId }; }